'use strict';

// Takes in any current disclaimers and the trimsArr.
// xforms any disclaimers found in the trimsArr
// returns the newDisclaimers

// needs to also return the trimsArr.

// modifies the trimArr
// 1) modify trim features, finding inline disclaimers and replacing them with HTML
// 2) return the trimFeatureDisclaimers that need to be added to the current set of disclaimers
// note:
// some disclaimers in trimsArr features may start with year_series_
define('features/vehicle-info/trim.xform.disclaimers',[], function () {
  return function viDisclaimers(currentDisclaimers, trimsArr) {
    var alreadyUsedDisclaimerArray = []; // once a disclaimer is used, stash it here so we don't use it again
    var newDisclaimers = []; // final set of new disclaimers to use
    // var seriesAndYearInDisclaimer = vehicleInfo.page.data.year + '_' + vehicleInfo.page.data.series + '_'; // build this from trimsArr
    var seriesAndYearInDisclaimer = '2019' + '_' + 'camry' + '_'; // build this from trimsArr

    for (var j = trimsArr.length - 1; j >= 0; j -= 1) {
      var featuresArr = trimsArr[j].features;
      // IF this trimsArr[j].features array contains text that matches one of the keys
      // in our currentDisclaimers, then replace it with HTML
      for (var k = 0; k < featuresArr.length; k += 1) {
        var feature = featuresArr[k];

        $.each(currentDisclaimers, function (property) { // eslint-disable-line no-loop-func
          var foundOne = (feature.indexOf(property) > -1);
          // some disclaimers DONT start with year_series_ so check for those too.
          var stripProp = property.replace(seriesAndYearInDisclaimer, '');
          var foundStripped = (feature.indexOf(stripProp) > -1);
          if (foundOne || foundStripped) {
            var replaceWith = '<sup class="color-red footnote"><a href="#" class="js-disclaimer-vi" data-disclaimer-id="' + currentDisclaimers[property].code + '">' + currentDisclaimers[property].code + '</a></sup>';
            var curFeature = feature.replace(/\[.*?\]/g, replaceWith);
            trimsArr[j].features[k] = curFeature;

            var result = {
              service_id: currentDisclaimers[property].code,
              disclaimer_copy: currentDisclaimers[property].description
            };

            // if we haven't already added this disclaimer to the DOM, then do so now.
            if (alreadyUsedDisclaimerArray.indexOf(property) === -1 && alreadyUsedDisclaimerArray.indexOf(stripProp) === -1) {
              newDisclaimers.push(result);
              alreadyUsedDisclaimerArray.push(property);
              alreadyUsedDisclaimerArray.push(stripProp);
            }
          }
        });
      }
    }
    return {
      trimFeatureDisclaimers: newDisclaimers,
      xformedTrimsArr: trimsArr
    };
  };
});

